import Navigation from "./modules/Navigation";
import Carousels from "./modules/Carousels";
import AjaxSearch from "./modules/AjaxSearch";
import {SidebarCart} from "./modules/SidebarCart";
import {ProductImageCarousel} from "./modules/WoocommerceProductPage";
import {productCarousels} from "./modules/ProductCarousels";
import {preorderSubmit} from "./modules/Preorder";
import StockFilter from "./modules/StockFilter";
import {ProductSwatches} from "./modules/Swatches";

AjaxSearch();
SidebarCart();
productCarousels();
new Navigation();
new Carousels();
new ProductImageCarousel();
preorderSubmit();
StockFilter();
ProductSwatches();


function sidebarToggle() {
    $('#shopSidebarOpen').on('click', function () {
        $('#shopSidebar').slideToggle();
        const toggleText = $('#shopSidebarOpen span');
        if (toggleText.text() === 'Rozwiń filtry') {
            toggleText.text('Zwiń filtry')
        } else {
            toggleText.text('Rozwiń filtry')
        }

    });
}

sidebarToggle();

function changeColorInAccountOrders() {
    const orderDetailsTable = document.querySelector('.woocommerce-table--order-details');

    if (orderDetailsTable) {
        const tableRows = orderDetailsTable.querySelectorAll('tr');
        const labels = document.querySelectorAll('.wc-item-meta-label');


        tableRows.forEach(row => {
            const header = row.querySelector('th');
            if (header && header.textContent.trim() === 'Rabat:') {
                row.classList.add('text-red');
            }
        });

        labels.forEach(label => {
            if (label.textContent.trim() === 'Ilość zrealizowanych:') {
                label.parentElement.classList.add('text-red');

            }
        })
    }

}

changeColorInAccountOrders();

const onSaleLabelVariation = function () {

    $('form.variations_form').on('show_variation', function (event, data) {
        //If variation is on sale, display the sale badge
        if (data.display_price < data.display_regular_price) {
            $(".product-type-variable .onsale").css("display", "block");
        }
        else {
            $(".product-type-variable .onsale").css("display", "none");
        }
    });
};

onSaleLabelVariation();


const variationEanNumber = function () {
    const eanWrapper = $('.ean_wrapper');

    if (!eanWrapper.length) {
        return;
    }

    const eanInner = eanWrapper.find('.ean')

    $(document).on('found_variation', '.variations_form', function(event, variation) {

        // Check if the variation has EAN
        if (variation.variable_ean_number ) {
            eanInner.text(variation.variable_ean_number);
            eanWrapper.removeClass('hidden');
        } else {
            eanInner.text('N/A');
            eanWrapper.addClass('hidden');
        }
    });

    // If no variation is selected
    $(document).on('reset_data', '.variations_form', function() {
        eanWrapper.addClass('hidden');
    });
};

variationEanNumber();